import createReducer from 'utils/redux/createReducer'

const initialState = {
	isOn: false,
	results: {},
	offset: 0,
	category: '',
	near: ''
}

export default createReducer(initialState, {
	CHANGE_CATEGORY: (currentState, action) => ({
		...currentState
	  , category: action.data
	  , results: {}
	}),
	CHANGE_NEAR: (currentState, action) => ({
		...currentState
	  , category: action.data
	})
  , SWITCH_YELP: (currentState, action) => ({
		...currentState
	  , isOn: !currentState.isOn
	})
  , ADD_RESULTS: (currentState, action) => ({
		...currentState
	  , results: {
			...currentState.results
		  , ...action.data
	  }
	  , offset: currentState.offset + action.data.length
	})
  , CLEAR_DATA: (currentState, action) => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/yelp.js